export enum ApplicationStepEnum {
    Step1 = 1,
    Step2 = 2,
    Step3 = 3,
    Step4 = 4,
    Step5 = 5,
    Step6 = 6,
    Step7 = 7,
    Step8 = 8,
    Step9 = 9,
}
